import { Component, ContentChild, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, distinctUntilChanged, forkJoin, map, Observable, of, Subject, takeUntil, tap } from 'rxjs';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { RTL } from 'src/app/@theme/const';
import { FormValidationService } from 'src/app/tabms/services/validation/form-validation/form-validation.service';
import { FormGroup } from '@angular/forms';
import { GridService } from '../../global/shared-grid/service/grid.service';
import { DELETESUCCESS, EDITSUCCESS, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { PermissionsListService } from 'src/app/tabms/services/global/permissions-list.service';
import { ParamsExtractorService } from 'src/app/tabms/services/global/params-extractor.service';
import { FieldDictionaryDto, LocalFormData } from 'src/app/tabms/models/base/base';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ImageHelperService } from 'src/app/tabms/services/global/image-helper.service';
import { DynamicSetFormValidatorsService } from 'src/app/tabms/services/global/dynamic-set-form-validators.service';
import { branchesDto } from 'src/app/tabms/models/admin/branch';
import { validate } from 'src/app/tabms/shared/utils/form-validation.utils';
import { is } from 'date-fns/locale';
import { isArray } from 'lodash';

@Component({
  selector: 'app-base-tool-bar',
  templateUrl: './base-tool-bar.component.html',
  styleUrl: './base-tool-bar.component.scss'
})
export class BaseToolBarComponent<T> implements OnInit, OnDestroy {
  systemMenuId
  currentLang
  pageName
  pageNameTitle
  form: FormGroup
  permissions

  headerId: string;
  footerData
  footerDataToRestore
  showCreate: boolean = false;
  screen
  headerParamsData
  customSaveStrategyDataArray: any[] = [];

  private destroy$: Subject<void> = new Subject<void>();

  @ContentChild('formComponent') formComponent

  @Input({ required: true }) headerServiceInstance
  @Input() headerKey: string;
  @Input() headerParams: string[]
  @Input() footerServiceInstance // Single footer service (backward compatibility)
  @Input() footerServices: { [key: string]: any } // Multiple footer services: { 'footer1': service1, 'footer2': service2 }
  @Input() params //if footer data has foreignKey or array of params per footer key: { 'footer1': [...], 'footer2': [...] }
  @Input() paramsMap: { [key: string]: string[] } // Map of footer keys to their params: { 'footer1': ['param1'], 'footer2': ['param2'] }
  @Input() hasImage //if header has Image
  @Input() deleteMode: 'row' | 'headefooterIDs' = 'row';
  @Input() deleteModeMap: { [key: string]: 'row' | 'headefooterIDs' } // Map of footer keys to delete modes
  // @Input() closeFormAfterSave: boolean = true

  @Input() canEdit: boolean = true;
  @Input() canDelete: boolean = true;
  @Input() canCreate: boolean = true;

  private destroy: Subject<void> = new Subject<void>()

  private keepOpenOnNextSave = false;

  // flag to save & design report (mirrors BaseEntry behavior)
  private SaveAndDesignReport = false;
  returnedFooterData: T[] = []

  // Store footer data per key
  footerDataMap: { [key: string]: any[] } = {}
  footerDataToRestoreMap: { [key: string]: any[] } = {}

  bulkFooterData: { [key: string]: any[] }[] = []


  constructor(
    private activatedRoute: ActivatedRoute,
    private fieldDictionaryListService: FieldDictionaryListService,
    private baseService: BaseService,
    private themeLayout: ThemeLayoutService,
    private gridService: GridService,
    public fieldsConfigService: FieldsConfigService<T>,
    private permissionListService: PermissionsListService,
    private paramsExtractor: ParamsExtractorService,
    private sessionService: SessionWrapperService,
    private imageHelper: ImageHelperService,
    private dynamicSetFormValidation: DynamicSetFormValidatorsService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.fieldsConfigService.getData();

    this.activatedRoute.params.pipe(takeUntil(this.destroy)).subscribe((params) => {
      this.systemMenuId = params['id'];
      this.fieldsConfigService.setMenuId(this.systemMenuId);
      this.fieldsConfigService.getData();
      this.fieldDictionaryListService.getPageFields(this.systemMenuId);
    });

    this.screen = activatedRoute.snapshot.url[0].path;

    this.themeLayout.directionChange.pipe(takeUntil(this.destroy)).subscribe({
      next: (dir) => {
        (dir === RTL) ? (this.currentLang = 'ar') : (this.currentLang = 'en');
      }
    })

    this.baseService.formBuild.pipe(takeUntil(this.destroy)).subscribe({
      next: (res) => {
        this.form = res
        // const currentValues = this.form.getRawValue();
        // Validators will be applied when we know if it's create or edit
      }
    })

    this.baseService.createFormDisplay.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.headerId = res?.id
        this.showCreate = res?.show
        // Apply validators: duplicate check only in create mode (no headerId)
        if (this.form) {
          this.dynamicSetFormValidation.setValidators(this.form, this.systemMenuId, this.destroy$, !this.headerId);
        }
        if (this.headerId) this.getById(this.headerId)

        this.baseService.sendEditId.next(res?.id);
      }
    })

    this.baseService.keepFormOpenOnSave.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => this.keepOpenOnNextSave = res
    })
  }

  ngOnInit(): void {
    this.permissionListService.getPagePermissions().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.permissions = res;
        }
      }
    });

    //delete row in grid
    this.gridService.deleteRow.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {

       // if (res) this.deleteRow(res?.id);
//>>>>>>> ahmed-bugfix-58-HR-System-Bugs
        if (res) {
          const id = res.id === '00000000-0000-0000-0000-000000000000' ? res.code : res.id;

          const footerKey = res?.footerServiceKey || null;
          this.deleteRow(res?.id, footerKey);
        }
      }
    })

    //save row in grid
    this.gridService.saveRow.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res === null) return
        let savedRow = res;

        // Extract footerServiceKey from the row data
        const footerKey = res?.footerServiceKey || null;

//>>>>>>> ahmed-bugfix-58-HR-System-Bugs

        // Get params for this specific footer
        const footerParams = this.getFooterParams(footerKey);
        if (footerParams && Array.isArray(footerParams)) {

          const { paramsData, objectKeys } = this.paramsExtractor.getParamsData(savedRow, footerParams)
          if (paramsData) {
            const filteredObj = Object.fromEntries(
              Object.entries(savedRow).filter(([key]) => !objectKeys.includes(key))
            );

            savedRow = { ...filteredObj, ...paramsData }
          }
        }

        // Remove footerServiceKey from data before saving
        delete savedRow.footerServiceKey;

         debugger
        (savedRow?.id) ? this.updateFooter(savedRow, footerKey) : this.createFooter(savedRow, footerKey);
      }
    })

    this.gridService.updateGridInfo.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res === null) return
debugger;
        // Support for multi footer: res can be an object with keys { footerKey: data[] }
        if (this.footerServices && res && typeof res === 'object' && !Array.isArray(res)) {
          // Multi footer mode
          Object.keys(res).forEach(footerKey => {
            let footerData = res[footerKey];
            const footerParams = this.getFooterParams(footerKey);

            if (footerParams && Array.isArray(footerParams)) {
              footerData = footerData.map(item => {
                const { paramsData, objectKeys } = this.paramsExtractor.getParamsData(item, footerParams)
                const filteredObj = Object.fromEntries(
                  Object.entries(item).filter(([key]) => !objectKeys.includes(key))
                );
                return { ...filteredObj, ...paramsData };
              });
            }

            this.footerDataToRestoreMap[footerKey] = res[footerKey];
            this.footerDataMap[footerKey] = footerData;
          });
        } else {
          // Single footer mode (backward compatibility)
          this.footerDataToRestore = res;
          this.footerData = res;
          if (this.params && Array.isArray(this.params)) {
            this.footerData = this.footerData.map(item => {
              const { paramsData, objectKeys } = this.paramsExtractor.getParamsData(item, this.params)
              const filteredObj = Object.fromEntries(
                Object.entries(item).filter(([key]) => !objectKeys.includes(key))
              );
              return { ...filteredObj, ...paramsData };
            });
          }
        }
      }
    }) //get updated data from footer grid

    this.baseService.createBulkDataF.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.bulkFooterData = [...res];
        }
      }
    }) //get bulkfooterdata

    //save form
    this.baseService.saveForm.pipe(takeUntil(this.destroy$)).subscribe({
      next: async (res) => {
        if (res) {
          debugger
          if (validate(this.form)) {
            if (this.customSaveStrategyDataArray?.length > 0) {
              // Check if customSaveStrategyDataArray has footer keys
              const footerKey = this.customSaveStrategyDataArray[0]?.footerServiceKey || null;
              if (this.customSaveStrategyDataArray) this.createBulkFooter(this.customSaveStrategyDataArray, footerKey);
              return;
            }
            if (this.bulkFooterData && this.bulkFooterData.length > 0) {
              // Support both multi-footer and single-footer formats
              // 1) Multi-footer: bulkFooterData = [ { 'EOServiceTrxF': rows[] }, { 'OtherFooter': rows[] } ]
              // 2) Single-footer: bulkFooterData = [ row1, row2, ... ]
debugger;
              const isMultiFooter =
                this.footerServices &&
                Array.isArray(this.bulkFooterData) &&
                this.bulkFooterData.length > 0 &&
                this.bulkFooterData.every((item: any) => {
                  if (!item || Array.isArray(item) || typeof item !== 'object') return false;
                  const keys = Object.keys(item);
                  return keys.length === 1 && Array.isArray(item[keys[0]]);
                });

              if (isMultiFooter) {
                // Multi-footer mode: each item contains footerKey -> rows[]
                this.bulkFooterData.forEach((item: any) => {
                  const footerKey = Object.keys(item)[0];
                  const dataArray = item[footerKey];
                  this.createBulkFooter(dataArray, footerKey);
                });
              } else {
                // Single-footer mode: bulkFooterData itself is the rows array
                this.createBulkFooter(this.bulkFooterData as any[], null);
              }
              return;
            }

            if (this.headerId) this.updateHeader();
            else (await this.createHeader()).subscribe();

          }
        }
      }
    })

    this.baseService.customSaveStrategy.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          if (Array.isArray(res) && res.length > 0) {
            this.customSaveStrategyDataArray = res;
          }
          else {
            const footerKey = res?.footerServiceKey || null;
            this.createFooter(res, footerKey);
          }
        }

      }
    })

    // // Listen to GridService custom save trigger (emitted by forms after header creation)
    // this.gridService.customSaveObservable.pipe(takeUntil(this.destroy$)).subscribe({
    //   next: (payload) => {
    //     if (!payload) return;
    //     const { data, footerServiceKey = null } = payload || {};
    //     if (Array.isArray(data) && data.length > 0) {
    //       this.createBulkFooter(data, footerServiceKey);
    //     } else if (data) {
    //       this.createFooter(data, footerServiceKey);
    //     }
    //   }
    // });

    // Save & Design
    this.baseService.saveAndDesgin.pipe(takeUntil(this.destroy$)).subscribe({
      next: async (save) => {
        if (save) {
          this.SaveAndDesignReport = true;
          if (validate(this.form)) {
            if (this.headerId) this.updateHeader();
            else (await this.createHeader()).subscribe();
          }
        }
      }
    })

    this.baseService.saveRetrieveLocalData.pipe(takeUntil(this.destroy$)).subscribe((saveorRetrieve: number) => {
      if (saveorRetrieve == 1)
        // temporary save
        this.saveLocalData();
      else if (saveorRetrieve == 2)
        // restore
        this.retrieveLocalData();
    });

    this.gridService.tableData.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe({
      next: (value) => {
        // debugger
        (value && value.length > 0) ? (this.returnedFooterData = value) : (this.returnedFooterData = []);
      }
    });
  }


  // Helper method to get footer service by key
  private getFooterService(footerKey: string | null): any {
    if (footerKey && this.footerServices) {
      return this.footerServices[footerKey];
    }
    return this.footerServiceInstance;
  }

  // Helper method to get params for specific footer
  private getFooterParams(footerKey: string | null): string[] | null {
    // debugger
    if (footerKey && this.paramsMap) {
      return this.paramsMap[footerKey];
    }
    if (footerKey && this.params && typeof this.params === 'object' && !Array.isArray(this.params)) {
      return this.params[footerKey];
    }
    return Array.isArray(this.params) ? this.params : null;
  }

  // Helper method to get delete mode for specific footer
  private getDeleteMode(footerKey: string | null): 'row' | 'headefooterIDs' {
    if (footerKey && this.deleteModeMap) {
      return this.deleteModeMap[footerKey] || 'row';
    }
    return this.deleteMode;
  }

  //delete row
  deleteRow(id: string, footerKey: string | null = null): void {
    const footerService = this.getFooterService(footerKey);
    if (!footerService) {
      return;
    }

    const deleteMode = this.getDeleteMode(footerKey);
    let delete$;

    switch (deleteMode) {
      case 'headefooterIDs':
        delete$ = footerService?.delete(this.headerId, id);
        break;
      case 'row':
      default:
        delete$ = footerService?.delete(id);
        break;
    }

    delete$?.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.baseService.showSuccessMessage(DELETESUCCESS);
        this.gridService.getTableDataByHeaderId(this.headerParamsData);
      },
      error: () => {
        this.baseService.showErrorMessage(OPERERROR);
      }
    })
  }

  //update footer grid
  updateFooter$(data, footerService: any): Observable<any> {
    // debugger
    return footerService?.update(data.id, data).pipe(tap(() => {
      this.baseService.showSuccessMessage(EDITSUCCESS)
      this.gridService.getTableDataByHeaderId(this.headerParamsData);
      this.gridService.isFooterUpdated.next(true);
      this.gridService.update([]);
    }));
  }

  updateFooter(data, footerKey: string | null = null) {
    const footerService = this.getFooterService(footerKey);
    if (!footerService) {
      return;
    }

    // data = { [this.headerKey]: this.headerId, ...data }
    data = { ...this.headerParamsData, ...data }
    this.updateFooter$(data, footerService).pipe(takeUntil(this.destroy$)).subscribe();
  }

  //create footer grid
  async createFooter(data, footerKey: string | null = null): Promise<void> {
    if (!data) return;

    const footerService = this.getFooterService(footerKey);
    if (!footerService) {
      return;
    }

    const proceed = () => {
      // const itemData = { [this.headerKey]: this.headerId, ...data };
      const itemData = { ...this.headerParamsData, ...data };
      //debugger
      footerService?.create(itemData).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.baseService.showSuccessMessage(SAVESUCCESS)
          // this.gridService.getTableDataByHeaderId({ [this.headerKey]: this.headerId })
          this.gridService.getTableDataByHeaderId(this.headerParamsData);
          this.gridService.update([]);
        },
        error: (err) => {
          this.baseService.showErrorMessage(OPERERROR);
        }
      });
    };

    if (!this.headerId) {
      (await this.createHeader('auto')).subscribe((id) => {
        if (id) {
          this.headerId = id;
          proceed();
        }
      });
    } else {
      proceed();
    }

  }

  async createBulkFooter(dataArray: T[], footerKey: string | null = null): Promise<void> {
    if (!dataArray || dataArray.length === 0) return;

    const footerService = this.getFooterService(footerKey);
    if (!footerService) {
      return;
    }

    const proceed = () => {
      const itemData = dataArray.map(item => {
        // Remove footerServiceKey before saving
        const { footerServiceKey, ...cleanItem } = item as any;
        return {
          ...this.headerParamsData,
          ...cleanItem
        };
      });
      //debugger
      footerService?.createBulk(itemData).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.baseService.showSuccessMessage(SAVESUCCESS)
          this.gridService.getTableDataByHeaderId(this.headerParamsData);
          debugger;
          this.gridService.update([]);
        },
        error: (err) => {
          this.baseService.showErrorMessage(OPERERROR);
        }
      });
    };

    if (!this.headerId) {
      (await this.createHeader('auto')).subscribe((id) => {
        if (id) {
          this.headerId = id;
          proceed();
        }
      });
    } else {
      proceed();
    }
  }

  //#region form submit
  async createHeader(context: 'manual' | 'auto' = 'manual'): Promise<Observable<any>> {
    if (!this.form) return of(null);
    //debugger
    let formData: T = this.form.getRawValue();

    // Normalize disabled fields: send 0 instead of empty string for disabled controls
    // This ensures calculated/readonly numeric fields don't go as ""
    Object.keys(this.form.controls).forEach((key) => {
      const ctrl = this.form.get(key);
      const currentValue = (formData as any)[key];
      if (ctrl && ctrl.disabled && currentValue === '') {
        (formData as any)[key] = 0;
      }
    });


    // const asyncBeforeSaveWork = this.formComponent.beforeSaveWork_async ? await this.formComponent.beforeSaveWork_async() : true;
    // const syncBeforeSaveWork = this.formComponent.beforeSaveWork ? this.formComponent.beforeSaveWork() : true;

    // console.log('form', this.form.value)
    // console.log("this.form.getRawValue()", this.form.getRawValue());
    Object.keys(formData).forEach(key => {
      if (key.toLowerCase() === 'branchid') {
        //  formData[key] =   this.sessionService.DefaultBranchID;
        //  this.form.getRawValue()[key] =   this.sessionService.DefaultBranchID;
        formData[key] = this.sessionService.DefaultBranchID
      }
    });

    if (this.hasImage) {
      formData = await this.imageHelper.formHasImage(formData, this.destroy$);
    }

    if (this.form.getRawValue() && this.form.valid) {
      //let body = { ...this.form.getRawValue(), branchId: this.systemMenuId };
      const asyncBeforeSaveWork = this.formComponent.beforeSaveWork_async ? await this.formComponent.beforeSaveWork_async() : true;
      const syncBeforeSaveWork = this.formComponent.beforeSaveWork ? this.formComponent.beforeSaveWork() : true;

      if (syncBeforeSaveWork && asyncBeforeSaveWork) {
        return this.headerServiceInstance?.create(formData).pipe(
          takeUntil(this.destroy$),
          tap(async (res: any) => {
            if (res) {

              this.headerId = res.result.id;
              this.baseService.showSuccessMessage(SAVESUCCESS); //&& this.closeFormAfterSave
              this.baseService.editForm.next(res.result);
              this.getHeaderData(res.result);
              if (this.formComponent.afterSaveWork) {
                this.formComponent.afterSaveWork(this.headerId)
              }
              else if (this.formComponent.afterSaveWork_async) {
                await this.formComponent.afterSaveWork_async(this.headerId)
              }
              // If Save & Design was requested, open designer now
              if (this.SaveAndDesignReport) {
                this.displayReportDesigner(this.headerId);
              }
              if (this.returnedFooterData && this.returnedFooterData.length > 0) {
                const returnedFooterData = this.returnedFooterData;
                // this.createFooter(returnedFooterData);
              }
              if (context === 'manual' && !this.keepOpenOnNextSave) {
                this.baseService.createFormDisplay.next({ show: false, id: null });
              }
              this.removeLocalStorage();
              this.baseService.refreshTable.next(true);
              this.headerServiceInstance.broadcastUpdate();
            }
          }),
          map((res: any) => {
            let id = res?.result.id || null
            // if (this.formComponent.afterSaveWork) {
            //   this.formComponent.afterSaveWork(id)
            // }
            // else if (this.formComponent.afterSaveWork_async) {
            //   await this.formComponent.afterSaveWork_async(id)
            // }
            return id
          }),
          catchError((err) => {
            this.baseService.showErrorMessage(OPERERROR);
            return of(null);
          })
        );
      } else {
        this.baseService.showErrorMessage('FormInValid');
        return of(null);
      }
    } else {
      this.baseService.showErrorMessage('FormInValid');
      return of(null);
    }
  }

  async updateHeader(): Promise<void> {
    let formData = { ...this.form.getRawValue() };
    if (formData.hasOwnProperty('elementtypecode')) delete formData.elementtypecode;

    if (this.hasImage) {
      formData = await this.imageHelper.formHasImage(formData, this.destroy$);
    }
    const asyncBeforeUpdateWork = this.formComponent.beforeUpdateWork_async ? await this.formComponent.beforeUpdateWork_async() : true;
    const syncBeforeUpdateWork = this.formComponent.beforeUpdateWork ? this.formComponent.beforeUpdateWork() : true;
    // console.log('this.form.getRawValue()',this.form.getRawValue(), this.form.value)
    if (syncBeforeUpdateWork && asyncBeforeUpdateWork) {
      this.headerServiceInstance?.update(this.headerId, formData).pipe(takeUntil(this.destroy$)).subscribe({
        next: async (res) => {
          // debugger
          let id = this.headerId;
          // If Save & Design was requested, open designer now
          if (this.SaveAndDesignReport) {
            this.displayReportDesigner(id);
          }
          if (this.formComponent.afterUpdateWork) {
            this.formComponent.afterUpdateWork(id)
          }
          else if (this.formComponent.afterUpdateWork_async) {
            await this.formComponent.afterUpdateWork_async(id)
          }
          // Handle multi footer or single footer
          if (this.footerServices && Object.keys(this.footerDataMap).length > 0) {
            // Multi footer mode
            debugger
            const updateObservables: Observable<any>[] = [];
            Object.keys(this.footerDataMap).forEach(footerKey => {
              const footerData = this.footerDataMap[footerKey];
              const footerService = this.getFooterService(footerKey);
              if (footerData && footerData.length > 0 && footerService) {
                footerData.forEach(item => {
                  const itemData = { ...item, [this.headerKey]: this.headerId };
                  updateObservables.push(this.updateFooter$(itemData, footerService));
                });
              }
            });

            if (updateObservables.length > 0) {
              forkJoin(updateObservables).pipe(takeUntil(this.destroy$)).subscribe({
                next: () => {
                  if (!this.keepOpenOnNextSave) {
                    this.baseService.createFormDisplay.next({ show: false, id: null });
                  }
                  this.baseService.refreshTable.next(true);
                  this.headerServiceInstance.broadcastUpdate();
                },
                error: (error) => {
                  this.baseService.showErrorMessage("error updating footer");
                }
              });
            } else {
              if (!this.keepOpenOnNextSave) {
                this.baseService.createFormDisplay.next({ show: false, id: null });
              }
              this.baseService.refreshTable.next(true);
              this.headerServiceInstance.broadcastUpdate();
            }
          } else if (this.footerData && this.footerData.length > 0) {
            // Single footer mode (backward compatibility)
            const footerData = this.footerData;
            const footerService = this.getFooterService(null);
            // debugger
            forkJoin(footerData.map(item => {
              item = { ...item, [this.headerKey]: this.headerId }
              return this.updateFooter$(item, footerService)
            })).pipe(takeUntil(this.destroy$)).subscribe({
              next: () => {
                if (!this.keepOpenOnNextSave) {
                  this.baseService.createFormDisplay.next({ show: false, id: null });
                }
                // if (this.keepOpenOnNextSave) {
                //   this.baseService.createFormDisplay.next({ show: true, id: '' });
                // }
                this.baseService.refreshTable.next(true);
                this.headerServiceInstance.broadcastUpdate();
              },
              error: (error) => {
                this.baseService.showErrorMessage("error updating footer");
              }
            });
          }
          else {
            if (!this.keepOpenOnNextSave) {
              this.baseService.createFormDisplay.next({ show: false, id: null });
            }
            // if (this.keepOpenOnNextSave) {
            //   this.baseService.createFormDisplay.next({ show: true, id: '' });
            // }
            this.baseService.refreshTable.next(true);
            this.headerServiceInstance.broadcastUpdate();
          }

          this.baseService.showSuccessMessage(EDITSUCCESS);

        },
        error: (err) => {
          this.baseService.showErrorMessage(OPERERROR);
        }
      })
    }

  }
  //#endregion

  //#region report
  private displayReportDesigner(id: string) {
    const properties = { Id: id };
    const reportsUrl = `${window.location.origin}/report-design/${JSON.stringify(properties)}`;
    window.open(reportsUrl);
    this.SaveAndDesignReport = false;
    this.baseService.createFormDisplay.next({ show: false, id: null });
    this.baseService.refreshTable.next(true);
  }
  //#endregion

  getById(id: string): void {
    // debugger
    let editRow
    this.headerServiceInstance.get(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        editRow = res.result;
        this.getHeaderData(editRow);
        this.baseService.editForm.next(editRow);
      }
    })
  }

  getHeaderData(data): void {

    // debugger
    if (this.headerParams && this.headerParams.length > 0) {
      this.headerParamsData = Object.fromEntries(
        this.headerParams
          .map(paramsKey => {
            const matchedKey = Object.keys(data).find(dataKey =>
              dataKey === paramsKey ||        // exact match
              paramsKey.includes(dataKey) ||  // "pagemenukey".includes("menukey")
              dataKey.includes(paramsKey)     // "menukey".includes("pagemenukey")
            );
            return matchedKey ? [paramsKey, (data as any)[matchedKey]] : null;
          })
          .filter((entry): entry is [string, any] => entry !== null)
      );
    }
    if (this.headerKey) {
      const headerId = { [this.headerKey]: this.headerId }
      this.headerParamsData = { ...this.headerParamsData, ...headerId };
    }

  }
  //#endregion

  //#region local data
  saveLocalData() {

    // Support multi footer in local storage
    const footerDataToSave = this.footerServices ? this.footerDataToRestoreMap : this.footerDataToRestore;

    // const localFormData: LocalFormData = { screen: this.screen, showrestorebtn: true, formvalue: this.form.value };
    const localFormData: LocalFormData = { screen: this.screen, showrestorebtn: true, formvalue: this.form.getRawValue(), footerData: footerDataToSave };
    let localDataArray: LocalFormData[];
    localDataArray = JSON.parse(localStorage.getItem('localFormData') || '[]');
    let indexToUpdate = localDataArray.findIndex((x) => x.screen == this.screen);
    if (indexToUpdate > -1) localDataArray[indexToUpdate] = localFormData;
    else localDataArray.push(localFormData);

    localStorage.setItem('localFormData', JSON.stringify(localDataArray));
  }

  retrieveLocalData() {
    const localDataArray: LocalFormData[] = JSON.parse(localStorage.getItem('localFormData') || '[]');
    const localData = localDataArray.find((x) => x.screen == this.screen);
    if (localData) {
      this.formComponent.form.patchValue(localData.formvalue);

      // Support multi footer in local storage retrieval
      if (this.footerServices && localData.footerData && typeof localData.footerData === 'object' && !Array.isArray(localData.footerData)) {
        // Multi footer mode
        this.gridService.setTableData(localData.footerData);
      } else {
        // Single footer mode
        this.gridService.setTableData(localData.footerData);
      }

      // debugger
      this.formComponent.afterGetDataWork ? this.formComponent.afterGetDataWork(localData.formvalue) : null;
    }
  }

  removeLocalStorage() {
    let localDataArray: LocalFormData[];
    localDataArray = JSON.parse(localStorage.getItem('localFormData') || '[]');
    let indexToDelete = localDataArray.findIndex((x) => x.screen == this.screen);
    if (indexToDelete > -1) localDataArray.splice(indexToDelete, 1);
    localStorage.setItem('localFormData', JSON.stringify(localDataArray));
    this.baseService.saveRetrieveLocalData.next(0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.gridService.setCoulmns([]);
    this.baseService.createFormDisplay.next(null)
    this.fieldsConfigService.setMenuId('');
    this.gridService.save(null); // Reset saveRow to avoid memory leaks
    this.gridService.delete(null)
  }
}
